import React from 'react';
import { CheckCircleOutlined, WarningOutlined, CloseCircleOutlined } from '@ant-design/icons';

interface PrereqItem {
  name: string;
  result: string;
  detail: string;
  status: 'good' | 'warning' | 'bad';
}

interface Props {
  checks: PrereqItem[];
}

const STATUS_CONFIG = {
  good: { icon: <CheckCircleOutlined />, color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f' },
  warning: { icon: <WarningOutlined />, color: '#fa8c16', bg: '#fff7e6', border: '#ffd591' },
  bad: { icon: <CloseCircleOutlined />, color: '#f5222d', bg: '#fff1f0', border: '#ffa39e' },
};

const PrerequisiteCard: React.FC<Props> = ({ checks }) => {
  if (!checks || checks.length === 0) return null;

  const allGood = checks.every(c => c.status === 'good');
  const hasBad = checks.some(c => c.status === 'bad');

  return (
    <div className="card-trendata" style={{ padding: 16, marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <h4 style={{ margin: 0, fontSize: 14, fontWeight: 600, color: '#061b31' }}>
          先决条件核查
        </h4>
        {allGood && <span style={{ fontSize: 12, color: '#52c41a' }}>全部通过</span>}
        {hasBad && <span style={{ fontSize: 12, color: '#f5222d' }}>存在问题</span>}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {checks.map((check, i) => {
          const cfg = STATUS_CONFIG[check.status];
          return (
            <div
              key={i}
              style={{
                display: 'flex', alignItems: 'center', gap: 6,
                padding: '6px 12px', borderRadius: 6,
                background: cfg.bg, border: `1px solid ${cfg.border}`,
                fontSize: 13,
              }}
              title={check.detail}
            >
              <span style={{ color: cfg.color }}>{cfg.icon}</span>
              <span style={{ fontWeight: 500 }}>{check.name}</span>
              <span style={{ color: '#666' }}>{check.result}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PrerequisiteCard;
